export const TENANT_POLICY_LINKS = [
    { key: 'platform_terms', label: 'Terms of Use' },
    { key: 'privacy_policy', label: 'Privacy Policy' },
    { key: 'tenant_supplement', label: 'Tenant Supplemental Terms' },
    { key: 'acceptable_use', label: 'Acceptable Use Policy' },
];
export const LANDLORD_POLICY_LINKS = [
    {
        key: 'platform_terms',
        label: 'Terms of Use',
        description: 'The terms governing your use of this platform.',
    },
    {
        key: 'privacy_policy',
        label: 'Privacy Policy',
        description: 'How we collect, use, and protect your data.',
    },
    {
        key: 'landlord_supplement',
        label: 'Landlord Supplemental Terms',
        description: 'Additional terms that apply to landlord accounts.',
    },
    {
        key: 'acceptable_use',
        label: 'Acceptable Use Policy',
        description: 'Rules for acceptable use of the platform.',
    },
];
//# sourceMappingURL=legal-policies.js.map